export default __webpack_public_path__ + "static/media/cs.ff7ea72b.svg";